



























import { Component, Vue, Ref } from 'vue-property-decorator';
import { FormModel } from 'ant-design-vue';
import { teamManage } from '../team';
import SelectUser from '@/components/selectUser.vue';
import { getUserById } from '@/utils/user';


type IUpdateTeamInfo = ITeam.IRequest.ITeamInfo;

interface IForm {
  name: string;
  comment: string;
  leader: string;
  leaderName: string;
  active: boolean;
}

@Component({
  components: {
    SelectUser,
  },
  filters: {
    getUserById,
  },
})
export default class TeamForm extends Vue {
  @Ref() private readonly editTeamForm!: FormModel;
  private loading = false;
  private rules = {
    name: [{ required: true, message: () => this.$t('form.required'), trigger: 'blur'}],
    leader: [{ required: true, message: () => this.$t('form.required'), trigger: 'change'}],
  };
  private form: IForm = {
    name: '',
    comment: '',
    leader: '',
    leaderName: '',
    active: true,
  };
  private created() {
    this.readyFormData();
  }
  private readyFormData() {
    if (!teamManage.editData.teamInfo) {
      return;
    }
    const { name, comment, leader, active, leaderName } = teamManage.editData.teamInfo!;
    this.form = {
      name,
      comment,
      leader,
      active,
      leaderName,
    };
  }
  private handleChange(value?: string) {
    this.form.leader = value ? value : '';
  }
  private handleSubmit() {
    this.editTeamForm.validate((valid) => {
      if (valid) {
        const {name, comment, leader, active} = this.form;
        const params: IUpdateTeamInfo = {
          name,
          comment,
          leader,
          active,
        };
        this.submitUpdateTeam(params);
      } else {
        return false;
      }
    });
  }
  private submitUpdateTeam(params: IUpdateTeamInfo) {
    this.loading = true;
    teamManage.requestUpdateTeam(params).then((res) => {
      this.addOwnerToMember(params.leader);
      this.loading = false;
      this.$message.success(res);
      this.endEdit();
    }).catch((err) => {
      this.loading = false;
      this.$message.warning(err);
    });
  }
  private addOwnerToMember(memberId: string) {
    if (!teamManage.editData.isCreate) {
      const result = teamManage.editData.teamInfo?.members.find((member) => member.id === memberId);
      if (result) {
        return;
      }
    }
    teamManage.requestAddMembers([memberId]).catch((err) => {
      this.$message.warning(err);
    });
  }
  private endEdit() {
    this.$emit('ok');
  }
}
